<div
  #form="ngForm"
  [formGroup]="soldToAddress"
  [class.was-validated]="isSubmitted"
>
  <div class="row">
    <div class="col-md-3 ml-12">
      <div class="vs-text-field">
        <label><span class="require">* </span>{{ "quoteCheckout.firstName" | cxTranslate }}</label>
        <input
          type="text"
          [ngClass]="
            (firstName.invalid &&
              (firstName.dirty || firstName.touched) &&
              !firstName.valid) ||
            (!soldToAddress.valid && isSubmitted && !firstName.valid)
              ? 'error'
              : ''
          "
          placeholder='{{ "quoteCheckout.firstName" | cxTranslate }}'
          formControlName="firstName"
          maxlength="20"
        />
        <label
          class="tag-section-custom-label-width custom-label"
          *ngIf="!soldToAddress.valid && isSubmitted && !firstName.valid"
        >
        {{ "quoteCheckout.firstName2" | cxTranslate }}
        </label>
      </div>
    </div>
    <div class="col-md-3">
      <div class="vs-text-field">
        <label><span class="require">* </span>{{ "quoteCheckout.lastName" | cxTranslate }}</label>
        <input
          type="text"
          [ngClass]="
            (lastName.invalid &&
              (lastName.dirty || lastName.touched) &&
              !lastName.valid) ||
            (!soldToAddress.valid && isSubmitted && !lastName.valid)
              ? 'error'
              : ''
          "
          placeholder='{{ "quoteCheckout.lastName" | cxTranslate }}'
          formControlName="lastName"
          maxlength="20"
        />
        <label
          class="tag-section-custom-label-width custom-label"
          *ngIf="!soldToAddress.valid && isSubmitted && !lastName.valid"
        >
        {{ "quoteCheckout.lastName2" | cxTranslate }}
        </label>
      </div>
    </div>
  </div>
  <div class="row mt-22">
    <div class="col-3 ml-12">
      <div class="vs-text-field">
        <label><span class="require">* </span>{{ "quoteCheckout.companyName" | cxTranslate }}</label>
        <input
          type="text"
          [ngClass]="
            (companyName.invalid &&
              (companyName.dirty || companyName.touched) &&
              !companyName.valid) ||
            (!soldToAddress.valid && isSubmitted && !companyName.valid)
              ? 'error'
              : ''
          "
          placeholder='{{ "quoteCheckout.companyName" | cxTranslate }}'
          formControlName="companyName"
          [attr.maxlength]="maxVal"
        />
        <label
          class="tag-section-custom-label-width custom-label"
          *ngIf="!soldToAddress.valid && isSubmitted && !companyName.valid"
        >
        {{ "quoteCheckout.companyName2" | cxTranslate }}
        </label>
      </div>
    </div>
  </div>
  <div class="row mt-22">
    <div class="col-3 ml-12">
      <div class="vs-text-field">
        <label><span class="require">* </span>{{ "quoteCheckout.endUserAddressL1" | cxTranslate }}</label>
        <input
          type="text"
          placeholder='{{ "quoteCheckout.endUserAddressL1" | cxTranslate }}'
          formControlName="line1"
          maxlength="35"
          [ngClass]="
            (line1.invalid && (line1.dirty || line1.touched) && !line1.valid) ||
            (!soldToAddress.valid && isSubmitted && !line1.valid)
              ? 'error'
              : ''
          "
        />
        <label
          class="tag-section-custom-label-width custom-label"
          *ngIf="!soldToAddress.valid && isSubmitted && !line1.valid"
        >
        {{ "quoteCheckout.endUserAddressL11" | cxTranslate }}
        </label>
      </div>
    </div>

    <div class="col-3">
      <div class="vs-text-field">
        <label>{{ "quoteCheckout.endUserAddressL2" | cxTranslate }}</label>
        <input
          type="text"
          placeholder='{{ "quoteCheckout.endUserAddressL2" | cxTranslate }}'
          formControlName="line2"
          maxlength="35"
        />
      </div>
    </div>
  </div>

  <div class="row mt-22">
    <div class="col-3 ml-12">
      <div>
        <label
          ><span class="require">* </span
          ><span class="label-custom">{{ "quoteCheckout.endUserCountry" | cxTranslate }}</span></label
        >

        <ng-select
          #countryFocus
          [searchable]="true"
          [clearable]="false"
          placeholder='{{ "quoteCheckout.selectPlaceholder" | cxTranslate }}'
          [ngClass]="
            (!soldToAddress.valid && isSubmitted && country.invalid) ||
            (!soldToAddress.valid && isSubmitted && country.value == 'Select')
              ? 'error-select'
              : ''
          "
          formControlName="country"
          (change)="saveCountryData()"
        >
          <ng-option
            *ngFor="let country of countryNames"
            [value]="country.isocode"
            >{{ country.name }}</ng-option
          >
        </ng-select>

        <label
          class="error"
          *ngIf="
            (!soldToAddress.valid && isSubmitted && country.invalid) ||
            (!soldToAddress.valid && isSubmitted && country.value == 'Select')
          "
        >
        {{ "quoteCheckout.endUserCountry2" | cxTranslate }} 
        </label>
      </div>
    </div>

    <div class="col-3">
      <div class="vs-text-field">
        <label
          ><span class="require" *ngIf="countryRegionNames?.length>0">* </span
          ><span class="label-custom">{{ "quoteCheckout.endUserState" | cxTranslate }} </span></label
        >

        <ng-select
          #stateFocus
          [searchable]="true"
          [clearable]="false"
          formControlName="state"
          placeholder='{{ "quoteCheckout.selectPlaceholder" | cxTranslate }}'
          [ngClass]="
            isSubmitted && (state.invalid || state.value == 'Select')
              ? 'error-select'
              : ''
          "
          (change)="selectState()"
        >
          <ng-option
            *ngFor="let region of countryRegionNames"
            [value]="region.isocode"
            >{{ region.name }}</ng-option
          >
        </ng-select>

        <label
          class="error"
          *ngIf="isSubmitted && (state.invalid || state.value == 'Select')"
        >
        {{ "quoteCheckout.endUserState2" | cxTranslate }}
        </label>
      </div>
    </div>
  </div>

  <div class="row mt-22">
    <div class="col-3 ml-12">
      <div class="vs-text-field">
        <label><span class="require">* </span>{{ "quoteCheckout.endUserCity" | cxTranslate }}</label>
        <input
          type="text"
          placeholder='{{ "quoteCheckout.endUserCity" | cxTranslate }}'
          formControlName="city"
          maxlength="35"
          [ngClass]="
            (city.invalid && (city.dirty || city.touched) && !city.valid) ||
            (!soldToAddress.valid && isSubmitted && !city.valid)
              ? 'error'
              : ''
          "
        />
        <label
          class="tag-section-custom-label-width custom-label"
          *ngIf="!soldToAddress.valid && isSubmitted && !city.valid"
        >
        {{ "quoteCheckout.endUserCity2" | cxTranslate }}
        </label>
      </div>
    </div>

    <div class="col-3">
      <div class="vs-text-field">
        <label><span class="require" *ngIf="country.value != 'CN'">* </span>{{ "quoteCheckout.endUserZip" | cxTranslate }}</label>
        <input
          type="text"
          placeholder='{{ "quoteCheckout.endUserZip" | cxTranslate }}'
          maxlength="10"
          [ngClass]="
            (postalCode.invalid &&
              (postalCode.dirty || postalCode.touched) &&
              !postalCode.valid) ||
            (!soldToAddress.valid && isSubmitted && !postalCode.valid)
              ? 'error'
              : ''
          "
          formControlName="postalCode"
        />
        <label
          class="tag-section-custom-label-width custom-label"
          *ngIf="!soldToAddress.valid && isSubmitted && !postalCode.valid"
        >
        {{ "quoteCheckout.endUserZip2" | cxTranslate }}
        </label>
      </div>
    </div>
  </div>
</div>
